<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'CommentBaseText',
  mixins: [baseMixin],
}
</script>

<template>
  <p class="text-subtitle-2 font-weight-medium mb-1">
    <slot></slot>
  </p>
</template>
